import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { useRouter } from '@savvy/deprecated-shared/hooks/use-router';
import { getReturnUrl } from '@savvy/deprecated-shared/utils/routing';

type GuestGuardProps = {
  children: ReactNode;
};

export function XGuestGuard(props: GuestGuardProps) {
  const { children } = props;
  const { isAuthenticated, user } = useAuth();
  const router = useRouter();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    if (isAuthenticated) {
      router.replace(getReturnUrl(router, user));
    } else {
      setChecked(true);
    }
  }, [router.isReady, isAuthenticated, user]);

  if (!checked) {
    return null;
  }

  // If got here, it means that the redirect did not occur, and that tells us that the user is
  // Not authenticated / authorized.

  return children;
}

XGuestGuard.propTypes = {
  children: PropTypes.node,
};
